import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as o } from "./index.es2361.js";
function a(p) {
  const { outline: l, fill: i, size: d, innerElementFill: t } = o(p);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: d,
      height: d,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n("g", { clipPath: "url(#clip0_260_3611)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M3.28912 15.7233C3.28912 14.6733 4.14012 13.8213 5.19012 13.8213C6.24012 13.8213 7.09212 14.6733 7.09212 15.7233C7.09212 16.7733 6.24012 17.6253 5.19012 17.6253C4.14012 17.6253 3.28912 16.7733 3.28912 15.7233Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.13873 2.27649C5.13873 1.22649 5.99073 0.375488 7.03973 0.375488C8.09073 0.375488 8.94273 1.22649 8.94273 2.27649C8.94273 3.32649 8.09073 4.17849 7.03973 4.17849C5.99073 4.17849 5.13873 3.32649 5.13873 2.27649Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.75682 9.0002C9.75682 7.9492 10.6088 7.0982 11.6588 7.0982C12.7088 7.0982 13.5608 7.9492 13.5608 9.0002C13.5608 10.0502 12.7088 10.9012 11.6588 10.9012C10.6088 10.9012 9.75682 10.0502 9.75682 9.0002Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M18.0004 2.6516H8.9424V1.9016H18.0004V2.6516Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.139 2.6516H0V1.9016H5.139V2.6516Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.0397 0.750488C6.19768 0.750488 5.5137 1.43372 5.5137 2.27649C5.5137 3.11951 6.19794 3.80349 7.0397 3.80349C7.88372 3.80349 8.5677 3.11925 8.5677 2.27649C8.5677 1.43398 7.88398 0.750488 7.0397 0.750488ZM4.7637 2.27649C4.7637 1.01925 5.78372 0.000488281 7.0397 0.000488281C8.29742 0.000488281 9.3177 1.019 9.3177 2.27649C9.3177 3.53372 8.29768 4.55349 7.0397 4.55349C5.78347 4.55349 4.7637 3.53347 4.7637 2.27649Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.9998 16.0983H7.0918V15.3483H17.9998V16.0983Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M3.289 16.0983H0V15.3483H3.289V16.0983Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.1901 14.1963C4.34746 14.1963 3.6641 14.8801 3.6641 15.7233C3.6641 16.5664 4.34746 17.2503 5.1901 17.2503C6.03299 17.2503 6.7171 16.5662 6.7171 15.7233C6.7171 14.8804 6.03299 14.1963 5.1901 14.1963ZM2.9141 15.7233C2.9141 14.4664 3.93274 13.4463 5.1901 13.4463C6.44721 13.4463 7.4671 14.4662 7.4671 15.7233C7.4671 16.9804 6.44721 18.0003 5.1901 18.0003C3.93274 18.0003 2.9141 16.9801 2.9141 15.7233Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.9995 9.3752H13.5605V8.6252H17.9995V9.3752Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.757 9.3752H0V8.6252H9.757V9.3752Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.6588 7.4732C10.8158 7.4732 10.1318 8.15644 10.1318 9.0002C10.1318 9.84284 10.8156 10.5262 11.6588 10.5262C12.502 10.5262 13.1858 9.84284 13.1858 9.0002C13.1858 8.15644 12.5018 7.4732 11.6588 7.4732ZM9.3818 9.0002C9.3818 7.74197 10.4018 6.7232 11.6588 6.7232C12.9158 6.7232 13.9358 7.74197 13.9358 9.0002C13.9358 10.2576 12.9156 11.2762 11.6588 11.2762C10.4019 11.2762 9.3818 10.2576 9.3818 9.0002Z",
              fill: l
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_260_3611", children: /* @__PURE__ */ e(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: t
          }
        ) }) })
      ]
    }
  );
}
a.__tags = [];
export {
  a as FilterIcon
};
//# sourceMappingURL=index.es273.js.map
